var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgShareFacebook = function SvgShareFacebook(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#080808",
    fillRule: "evenodd",
    d: "M16 0C7.163 0 0 7.163 0 16s7.163 16 16 16 16-7.163 16-16S24.837 0 16 0m1.668 16.703v8.705h-3.602v-8.705h-1.8v-3h1.8v-1.8C14.066 9.454 15.082 8 17.969 8h2.403v3H18.87c-1.124 0-1.198.42-1.198 1.202l-.004 1.501h2.721l-.318 3z",
    clipRule: "evenodd"
  })));
};
export default SvgShareFacebook;